// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

export const cadastrarPostagemService = async (data: any) => {
  const URL = `${Globais.DOMINIOBACK}/postagens`;
  try {
    const response = await axios.post(URL, data);
    if (response && response.data) {
      return response.data;
    }
  } catch (error) {
    console.error(error);
  }
};
